export default function (instance) {
    return {
        getContracts(params = null){
            return instance.get('contract', params)
        },
        getContract(params){
            return instance.get('contract', params)
        },
        addContract(params){
            return instance.postForm('contract', params)
        },
        cancelSubscription(contract_id){
            return instance.postForm('contract/' + contract_id + '/cancel-subscription')
        },
    }
}